module.exports = __webpack_public_path__ + "img/gate.1ee416c0.webp";